import { render, staticRenderFns } from "./templateSelect.vue?vue&type=template&id=db5f5f0e"
import script from "./templateSelect.vue?vue&type=script&lang=js"
export * from "./templateSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports